<template>
  <b-modal
    id="tagpanelisttable"
    size="xl"
    centered
    hide-footer
    hide-header
    :visible="showTagPanelist"
    no-close-on-backdrop
    @hidden="closeModal()"
  >
    <div class="p-3 d-flex align-items-center justify-content-between">
      <div class="b-modal-header">View Internal Panelists</div>
      <div @click="closeModal()" class="pointer">
        <img
          class="rotate-on-hover"
          src="../../../assets/img/accessconnew/blueCross.svg"
          alt=""
        />
      </div>
    </div>
    <hr class="m-0" />
    <div class="d-flex justify-content-between align-items-center w-100 p-3">
      <div class="exc-seacrh position-relative w-50">
        <span>
          <img
            class="search-pos"
            src="../../../assets/img/search-bar-icon.svg"
            alt=""
          />
        </span>
        <b-form-input
          class="search-input"
          type="search"
          v-model.trim="searchQuery"
          debounce="500"
          @update="searchPanelist"
          placeholder="Search Panelist"
        ></b-form-input>
      </div>

      <div class="d-flex">
        <div class="tp-bluetxt mr-4">
          Selected Panelist:&nbsp; {{ formattedSelectedLength }}
        </div>
      </div>
    </div>
    <hr class="m-0" />

    <b-overlay :show="LoaderStatus" rounded="sm">
      <div class="p-3">
        <div class="kanban-exc-main-table">
          <div class="exc-table-head">
            <div
              class="common-single-checkbox"
              style="width: 10%"
              :style="
                $route.name == 'VendorKanban'
                  ? 'padding-left: 17px'
                  : 'padding-left: 27px'
              "
            >
              <b-form-checkbox
                v-model="allSelected"
                @change="selectAllPanelist"
              ></b-form-checkbox>
            </div>
            <div style="width: 30%">
              <span class="mr-2">User name</span>
              <template v-if="statusValue == 'name'">
                <img
                  @click="sort('name', false)"
                  v-if="sortByValue === true"
                  class="pointer"
                  src="../../../assets/img/accessconnew/ascSort.svg"
                  alt=""
                />
                <img
                  v-if="!sortByValue"
                  @click="sort('name', true)"
                  class="pointer"
                  src="../../../assets/img/accessconnew/descSort.svg"
                  alt=""
                />
              </template>
              <img
                v-else
                @click="sort('name', true)"
                class="pointer img-h"
                src="../../../assets/img/accessconnew/nosort.svg"
                alt=""
              />
            </div>
            <div style="width: 30%">
              <span class="mr-2">Email</span>
              <template v-if="statusValue == 'email'">
                <img
                  @click="sort('email', false)"
                  v-if="sortByValue === true"
                  class="pointer"
                  src="../../../assets/img/accessconnew/ascSort.svg"
                  alt=""
                />
                <img
                  v-if="!sortByValue"
                  @click="sort('email', true)"
                  class="pointer"
                  src="../../../assets/img/accessconnew/descSort.svg"
                  alt=""
                />
              </template>
              <img
                v-else
                @click="sort('email', true)"
                class="pointer"
                src="../../../assets/img/accessconnew/nosort.svg"
                alt=""
              />
            </div>
            <div style="width: 30%; padding-left: 40px">
              <span class="mr-2">Role Type</span>
            </div>
          </div>

          <div class="exc-table-body">
            <div v-if="!LoaderStatus && panelDetails.length == 0" class="h-100">
              <div
                v-if="panelDetails.length === 0 && searchQuery == ''"
                class="
                  d-flex
                  align-items-center
                  flex-column
                  justify-content-center
                  h-100
                "
              >
                <div>
                  <img
                    src="../../../assets/img/accessconnew/emptyprivilageBig.svg"
                    alt=""
                  />
                </div>
                <div class="mt-2 text-center access-font-color">
                  No records found.
                </div>
              </div>
              <div
                v-else-if="
                  panelDetails.length === 0 &&
                  searchQuery !== '' &&
                  !LoaderStatus
                "
                class="
                  d-flex
                  align-items-center
                  flex-column
                  justify-content-center
                  h-100
                "
              >
                <div>
                  <img
                    src="../../../assets/img/accessconnew/emptyprivilageBig.svg"
                    alt=""
                  />
                </div>
                <div class="mt-2 text-center access-font-color">
                  No matching results for &nbsp;
                  <span class="access-font-color-b text-center"
                    >"{{ searchQuery }}"</span
                  >.
                </div>
              </div>
            </div>
            <div v-else>
              <div
                :style="
                  panellistSelected.includes(panel.panelID) &&
                  'background : #E1EEF7 !important'
                "
                class="
                  kanban-exc-table-row
                  mt-3
                  d-flex
                  justify-content-between
                  align-items-center
                  position-relative
                "
                v-for="panel in panelDetails"
                :key="panel.panelID"
              >
                <div class="kanban-tp-blueline"></div>
                <div class="common-single-checkbox pl-3" style="width: 7%">
                  <b-form-checkbox
                    :value="panel.panelID"
                    v-model="panellistSelected"
                    @change="deselect"
                  >
                  </b-form-checkbox>
                </div>

                <div
                  style="width: 30%"
                  class="d-flex align-items-center text-truncate pr-1"
                >
                  <img
                    src="../../../assets/img/newvendorflow/user.svg"
                    class="mr-1"
                    alt=""
                  />
                  {{ panel.name }}
                </div>
                <div style="width: 30%" class="text-truncate pr-1 pl-2">
                  {{ panel.email }}
                </div>
                <div style="width: 30%" class="text-truncate pr-1 pl-5">
                  {{ panel.roleName }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-overlay>
    <div
      v-if="allPanelist"
      class="
        acs-paginaTion-new
        d-flex
        justify-content-between
        align-items-center
      "
    >
      <div class="d-flex">
        <span class="acs-gotopage-text p-1 mr-2">Go to page</span>
        <b-form-input
          v-model="goToPage"
          @keyup.enter="
            goToPage === null || goToPage == '' || iscontainsNumber
              ? goToPages(goToPage)
              : ''
          "
          @keypress="NumbersOnly"
          type="text"
          class="acs-pagination-num"
        ></b-form-input>
        <div class="acs-pagination-addbtn">
          <span
            @click="
              goToPage === null || goToPage == '' || !iscontainsNumber
                ? ''
                : goToPages(goToPage)
            "
            :class="
              goToPage === null || goToPage == '' || !iscontainsNumber
                ? 'disableDeleteIcon pl-3 mt-1'
                : 'pointer pl-3 mt-1'
            "
          >
            <img src="../../../assets/panelist/page_arrow.svg" alt />
          </span>
        </div>
      </div>

      <div class="pagination">
        <b-pagination
          v-model.number="currentPage"
          @input="getPanelPagination(), (goToPage = null)"
          :total-rows="total"
          :per-page="pageCount"
          align="center"
          first-number
          last-number
        >
          <template #prev-text>
            <span>
              <img src="../../../assets/img/accessconnew/pageleft.svg" alt />
            </span>
          </template>
          <template #next-text>
            <span>
              <img src="../../../assets/img/accessconnew/pageright.svg" alt />
            </span>
          </template>
        </b-pagination>
      </div>
      <div class="d-flex align-items-center">
        <PageInput :pagecount="pageCount" @update-value="updatePage" />

        <div class="acs-gotopage-text mr-2 ml-4 d-flex justify-content-end">
          Showing :

          <div
            class="text-truncate ml-2 results-individual-width"
            v-if="pageStart > total"
          >
            0
          </div>
          <div class="text-truncate ml-2 results-individual-width">
            {{ pageStart }}
          </div>
          <div class="text-truncate results-individual-width">-</div>
          <div class="text-truncate results-individual-width">
            {{ pageEnd }}
          </div>
          <div class="text-truncate ml-1 results-individual-width">of</div>
          <div class="text-truncate ml-1 results-individual-width">
            {{ total }}
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-end p-3 bluebtn">
      <b-button @click="closeModal()" class="acs-cancelBtn-modal pointer mr-3"
        >Cancel</b-button
      >

      <b-button
        :disabled="panellistSelected.length == 0"
        @click="tagPanelist()"
        class="acs-addBtn-modal pointer"
        >Tag Panelist</b-button
      >
    </div>
  </b-modal>
</template>

<script>
import {
  getPanelPagination,
  getActivePanelist,
} from "../../../utils/apiFunctions";
import { NumbersOnly } from "../../../controllers/Candidate/helpers";
import PageInput from "../../../components/InputComponents/PaginationInput.vue";
export default {
  name: "TagPanelist",
  props: {
    showTagPanelist: Boolean,
    panelList: Array,
    selectedPanelists: Array,
  },
  data() {
    return {
      total: 0,
      currentPage: 1,
      pageCount: 10,
      goToPage: null,
      statusValue: "createdAt",
      sortByValue: false,
      searchQuery: "",
      pageStart: "",
      pageEnd: "",
      fullData: [],
      allPanelist: false,
      LoaderStatus: false,
      allSelected: false,
      panelDetails: this.panelList,
      isSelectedAll: false,
      panellistSelected: [],
      selPanelDetails: [],
    };
  },
  components: {
    PageInput,
  },
  created() {
    if (this.panelList.length == 0) {
      this.allPanelist = true;
      this.getPanelPagination();
    } else {
      let panelvalues = JSON.parse(JSON.stringify(this.panelList));
      panelvalues.map((obj) => {
        obj.name = obj.username;
        obj.active = obj.isActive;
        delete obj.isActive;
        delete obj.username;
        return obj;
      });
      const uniqueset = new Set();
      this.panelDetails = panelvalues.filter((item) => {
        const value = item.panelID;
        return uniqueset.has(value) ? false : uniqueset.add(value);
      });
      this.getActivePanel();
    }
    if (this.selectedPanelists.length != 0) {
      this.panellistSelected = this.selectedPanelists.map((obj) => {
        return obj.panelID;
      });
      this.selPanelDetails = this.selectedPanelists;
      // this.deselect();
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.pageCount);
    },
    iscontainsNumber() {
      return /^[1-9]\d*$/.test(this.goToPage);
    },
    formattedSelectedLength() {
      return this.panellistSelected.length < 10
        ? "0" + this.panellistSelected.length
        : this.panellistSelected.length;
    },
  },
  methods: {
    tagPanelist() {
      this.$emit("select-panelist", this.selPanelDetails);
      this.closeModal();
    },
    updatePage(value) {
      this.pageCount = value;
      this.currentPage = 1;
      this.getPanelPagination();
    },
    NumbersOnly(evt) {
      NumbersOnly(evt);
    },
    goToPages(index) {
      this.currentPage = Math.min(Math.max(1, index), this.totalPages);
      this.goToPage = null;
      this.getPanelPagination();
    },
    selectAllPanelist() {
      if (this.allSelected) {
        for (let panel of this.panelDetails) {
          if (
            (panel.active || panel.active === null) &&
            !this.panellistSelected.includes(panel.panelID)
          ) {
            this.panellistSelected.push(panel.panelID);
          }
        }
      } else {
        for (let panel of this.panelDetails) {
          if (panel.active || panel.active === null) {
            const index = this.panellistSelected.indexOf(panel.panelID);
            if (index !== -1) {
              this.panellistSelected.splice(index, 1);
            }
          }
        }
      }
      this.deselect();
    },
    deselect() {
      this.allSelected = false;
      const containsAll = this.panelDetails.every((element) => {
        return this.panellistSelected.includes(element.panelID);
      });
      if (containsAll) {
        this.allSelected = true;
      }
      let value = this.panelDetails.filter((obj) =>
        this.panellistSelected.includes(obj.panelID)
      );
      for (let val of value) {
        let vals = this.selPanelDetails.some(
          (obj) => obj.panelID == val.panelID
        );

        if (!vals) {
          this.selPanelDetails.push(val);
        }
      }
      const uniqueset = new Set();
      this.selPanelDetails = this.selPanelDetails.filter((item) => {
        const value = item.panelID;
        return uniqueset.has(value) ? false : uniqueset.add(value);
      });
      this.selPanelDetails = this.selPanelDetails.filter((obj) => {
        if (this.panellistSelected.includes(obj.panelID)) {
          return obj;
        }
      });
    },
    sort(data, sortBool) {
      this.statusValue = data;
      this.sortByValue = sortBool;
      if (this.allPanelist) {
        this.getPanelPagination();
      } else {
        this.sortObjectsByKey();
      }
    },
    searchPanelist() {
      if (this.allPanelist) {
        this.getPanelPagination();
      } else {
        this.searchObjectsByKeyValue();
      }
    },
    searchObjectsByKeyValue() {
      const lowerCaseValue = this.searchQuery.toLowerCase();
      this.panelDetails = this.fullData.filter(
        (item) =>
          item.name &&
          item.name.toString().toLowerCase().includes(lowerCaseValue)
      );
      if (this.panelDetails.length == 0 && !this.searchQuery) {
        this.panelDetails = this.fullData;
      }
      this.sortObjectsByKey();
    },
    sortObjectsByKey() {
      let order = this.sortByValue ? "asc" : "desc";
      this.panelDetails = this.panelDetails.slice().sort((a, b) => {
        let valueA = a[this.statusValue];
        let valueB = b[this.statusValue];
        valueA = valueA ? valueA.toString().toLowerCase() : valueA;
        valueB = valueB ? valueB.toString().toLowerCase() : valueB;
        if (valueA < valueB) return order === "asc" ? -1 : 1;
        if (valueA > valueB) return order === "asc" ? 1 : -1;
        return 0;
      });
    },
    closeModal() {
      this.$emit("hide-modal");
    },
    async getPanelPagination() {
      try {
        this.LoaderStatus = true;
        let payload = {
          type: "1",
          count: this.pageCount,
          page: this.currentPage - 1,
          sortBy: {
            column: this.statusValue,
            order: this.sortByValue,
          },
          searchQuery: this.searchQuery,
        };
        const res = await getPanelPagination(payload);
        if (res.status == 200) {
          this.LoaderStatus = false;
          this.panelDetails = res.data.data.data;
          this.panelDetails.forEach((obj) => {
            obj.view = false;
          });
          this.pageStart = res.data.data.pageStart;
          this.pageEnd = res.data.data.pageEnd;
          this.total = res.data.data.total;
          this.checkSelectAll();
        } else {
          this.LoaderStatus = false;
        }
      } catch (err) {
        this.LoaderStatus = false;
        this.errorModal("Something went wrong");
        throw err;
      }
    },
    async getActivePanel() {
      try {
        this.LoaderStatus = true;
        let panelUserIDs = this.panelDetails.map((obj) => obj.userID);

        let payload = {
          panelUserIDs: panelUserIDs,
        };
        const res = await getActivePanelist(payload);
        if (res.status == 200) {
          this.LoaderStatus = false;
          this.panelDetails = res.data.data.Details;
          this.panelDetails.forEach((obj) => {
            obj.view = false;
          });
          this.fullData = this.panelDetails;
          this.checkSelectAll();
        } else {
          this.LoaderStatus = false;
        }
      } catch (err) {
        this.LoaderStatus = false;
        this.errorModal("Something went wrong");
        throw err;
      }
    },
    checkSelectAll() {
      let isSelectedAll = true;
      if (this.panelDetails.length !== 0) {
        for (const record of this.panelDetails) {
          if (
            this.panellistSelected.filter((value) => value == record.panelID)
              .length === 0
          ) {
            isSelectedAll = false;
            break;
          }
        }
      } else {
        isSelectedAll = false;
      }

      this.allSelected = isSelectedAll;
    },
  },
};
</script>

<style>
.kanban-exc-table-row {
  width: 100%;
  position: relative;
  border-radius: 5px;
  border: 0.5px solid #e5e5e5;
  background: #fcfcfc;
  box-shadow: 0px 4px 15px 0px #c4c4c480;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 15px;
  color: #20639b;
  font-family: "lato", sans-serif;
  padding: 10px;
  margin: 8px 0px;
}

.kanban-exc-table-row:hover {
  background: #e7e8f5;
}
</style>
